<template>
  <div class="admin-comment-request-comments-new">
    <header-component></header-component>
    <div class="wrapper">
      <md-card>
        <md-card-content>
          <div class="form-content">
            <p>店舗名</p>
            {{shop.name}}
          </div>
          <div class="form-content">
            <p>ID</p>
            {{shop.id}}
          </div>
          <div class="form-content">
            <p>リクエスト日時</p>
            {{shop.created_at}}
          </div>
          <div class="form-content">
            <form>
              <md-input-container>
                <label>コメント内容</label>
                <md-input v-model="shop.comment"></md-input>
              </md-input-container>
            </form>
          </div>
          <div>
            <md-button class="md-raised md-primary" v-on:click="onSubmit">承認</md-button>
            <md-button class="md-raised md-accent" v-on:click="onDelete">削除</md-button>
          </div>
        </md-card-content>
      </md-card>
      <router-link :to="{ name: 'AdminCommentRequestsIndex'}"><i class="el-icon-caret-left"></i>戻る</router-link>
    </div>
  </div>
</template>

<script>
import HeaderComponent from '../../../Header.vue'
import firebaseApp from '../../../../firebaseApp'
import router from '../../../../router'
import authenticateUser from '../../../../auth'
const db = firebaseApp.firestore()
const shopRef = db.collection('shops')

let data = {
  shop: {}
}

export default {
  name: 'admin-comment-request-comments-new',
  data () {
    return data
  },
  components: {
    HeaderComponent
  },
  created () {
    authenticateUser().then(() => {
      db.doc(`comment_requests/${this.$route.params.id}`).get().then((CommentDoc) => {
        if (CommentDoc.exists) {
          data.shop.id = CommentDoc.data().shop_id
          data.shop.comment = CommentDoc.data().content
          data.shop.created_at = CommentDoc.data().created_at
        } else {
          router.push({name: 'NotFound'})
        }
      }).then(() => {
        shopRef.doc(data.shop.id).get().then((shopDoc) => {
          if (shopDoc.exists) {
            data.shop.name = shopDoc.data().name
          } else {
            alert('コメントを追加先の店舗が見つかりませんでした。<br>店舗情報より再度コメントを登録してください')
          }
        })
      })
    })
  },
  mounted () {
    this.$material.setCurrentTheme('admin')
  },
  destroyed () {
    this.$material.setCurrentTheme('default')
  },
  methods: {
    onSubmit: function () {
      shopRef.doc(data.shop.id).get().then(function (shopDoc) {
        var comments = shopDoc.data().comments
        comments.push({ content: data.shop.comment, created_at: data.shop.created_at })
        shopRef.doc(data.shop.id).update({ comments: comments })
      }).then(() => {
        db.collection('comment_requests').doc(this.$route.params.id).delete().then(() => {
          router.push({name: 'AdminCommentRequestsIndex', query: { registered: true }})
        }).catch(error => {
          alert('リクエストの削除に失敗しました。' + error)
        })
      })
    },
    onDelete: function () {
      if (confirm('店舗を削除してもよろしいですか？')) {
        db.doc(`comment_requests/${this.$route.params.id}`).delete().then(() => {
          router.push({name: 'AdminCommentRequestsIndex'})
        }).catch(function (error) {
          alert(error + 'リクエストの削除に失敗しました。もう一度削除してください。')
        })
      }
    }
  }
}
</script>

<style scoped>

header {
  margin-left: 150px;
}

.wrapper {
  width: 960px;
  height: auto;
  margin: 0 auto;
}

.form-content {
  width: 100%;
  height: 90px;
}
.form-content p {
  font-weight: bold;
}

.el-icon-caret-left {
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/CommentRequests/Comments/New.vue